import React from 'react'

import { BaseContent, Skeleton, ToolbarButton } from '@fourthwall/components'
import type { ToolbarButtonProps } from '@fourthwall/components/dist/common/ToolbarButton/types'
import { CloseIcon, PencilIcon } from '@fourthwall/icons'

import * as S from './ShippingGroupTile.styled'

type ShippingGroupViewProps = {
  name: string
  productsContent: string
  productsContentLoading: boolean
  countriesContent: string
  onEdit: () => void
  onDelete: () => void
}

export const ShippingGroupTileView = ({
  name,
  productsContent,
  productsContentLoading,
  countriesContent,
  onEdit,
  onDelete,
}: ShippingGroupViewProps) => {
  const renderToolbarButton = (props: ToolbarButtonProps) => (
    <ToolbarButton placement="top" size="extraSmall" iconSize={12} {...props} />
  )

  return (
    <S.Container>
      <div>
        <S.Label>{name}</S.Label>
        <BaseContent>
          {productsContentLoading ? (
            <Skeleton>
              <Skeleton.Shape width="50%" height={24} />
            </Skeleton>
          ) : (
            productsContent
          )}
        </BaseContent>
      </div>
      <div>
        <S.Label>Limit shipping to</S.Label>
        <BaseContent>{countriesContent}</BaseContent>
      </div>
      <S.Actions>
        {renderToolbarButton({ label: 'Edit', icon: PencilIcon, onClick: onEdit })}
        {renderToolbarButton({ label: 'Remove', icon: CloseIcon, onClick: onDelete })}
      </S.Actions>
    </S.Container>
  )
}
